import { QueryClient } from '@tanstack/react-query';

// 創建並導出 QueryClient 實例
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5分鐘
      gcTime: 10 * 60 * 1000, // 10分鐘 (原 cacheTime)
      retry: 2, // 失敗時重試2次
      refetchOnWindowFocus: false, // 視窗聚焦時不自動重新獲取
    },
    mutations: {
      retry: 1, // 變更操作失敗時重試1次
    },
  },
});

export default queryClient; 